import { render, staticRenderFns } from "./WithholdingTableTaxes.vue?vue&type=template&id=66eeb80d&scoped=true"
import script from "./WithholdingTableTaxes.vue?vue&type=script&lang=js"
export * from "./WithholdingTableTaxes.vue?vue&type=script&lang=js"
import style0 from "./WithholdingTableTaxes.vue?vue&type=style&index=0&id=66eeb80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eeb80d",
  null
  
)

export default component.exports